"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAction201ResponseToJSON = exports.CreateAction201ResponseFromJSONTyped = exports.CreateAction201ResponseFromJSON = exports.instanceOfCreateAction201Response = void 0;
var runtime_1 = require("../runtime");
var Action_1 = require("./Action");
/**
 * Check if a given object implements the CreateAction201Response interface.
 */
function instanceOfCreateAction201Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateAction201Response = instanceOfCreateAction201Response;
function CreateAction201ResponseFromJSON(json) {
    return CreateAction201ResponseFromJSONTyped(json, false);
}
exports.CreateAction201ResponseFromJSON = CreateAction201ResponseFromJSON;
function CreateAction201ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (0, Action_1.ActionFromJSON)(json['data']),
    };
}
exports.CreateAction201ResponseFromJSONTyped = CreateAction201ResponseFromJSONTyped;
function CreateAction201ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, Action_1.ActionToJSON)(value.data),
    };
}
exports.CreateAction201ResponseToJSON = CreateAction201ResponseToJSON;
